module.exports = __webpack_public_path__ + "48742ac2d3d12027afa1170b693b2930.svg";